"use client"

import { useState, useCallback } from "react"

interface ToastData {
  id: string
  type: "success" | "error" | "info"
  message: string
}

const MAX_TOASTS = 3

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const showToast = useCallback((type: "success" | "error" | "info", message: string) => {
    const id = Math.random().toString(36).substr(2, 9)
    const newToast = { id, type, message }
    
    setToasts((prev) => {
      let updatedToasts = [...prev, newToast]
      
      // Si excede el máximo, remover el primero (más antiguo)
      if (updatedToasts.length > MAX_TOASTS) {
        updatedToasts = updatedToasts.slice(1) // Remover el primer elemento
      }
      
      return updatedToasts
    })
  }, [])

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  return {
    toasts,
    showToast,
    removeToast,
  }
}
